module.exports = __webpack_public_path__ + "img/Phone_07.7142a171.jpg";